const LeadershipSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
              LEADERSHIP
            </p>
            <h2 className="font-serif text-4xl font-bold text-navy-primary">
              Physician-Led Excellence
            </h2>
          </div>

          <div className="bg-navy-primary rounded-3xl p-12 lg:p-16 text-white shadow-2xl">
            <div className="flex flex-col items-center text-center">
              <div className="w-32 h-32 flex items-center justify-center bg-gold/20 rounded-full mb-8">
                <i className="ri-user-line text-6xl text-gold"></i>
              </div>

              <h3 className="text-3xl font-bold mb-2">
                Dr. Izza Raza Sahi, MBBS
              </h3>
              <p className="text-lg text-gold mb-8">
                Owner & Principal Consultant
              </p>

              <div className="w-20 h-0.5 bg-gold mb-8"></div>

              <p className="text-base text-gray-light leading-relaxed max-w-2xl">
                Dr. Sahi brings clinical expertise and operational insight to
                every consulting engagement, ensuring that strategic
                recommendations are grounded in real-world clinical practice
                experience. With a physician-led approach, IRS Ventures delivers
                consulting that understands the unique challenges and
                opportunities facing modern clinical organizations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;